import React, { useState } from "react";
import { Checkbox } from "@mui/material";
import { asyncPutData } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../contexts/alert/AlertProvider";

interface ICheckboxUpdate {
  apiCode: string;
  idUpdate: string;
  fieldUpdate: string;
  defaultChecked?: boolean;
  emailCheckSelf?: string;
}

function CheckboxUpdate({
  defaultChecked,
  apiCode,
  idUpdate,
  fieldUpdate,
  emailCheckSelf,
}: ICheckboxUpdate) {
  const { showAlert } = useAlertContext();
  const { token, profile } = useSelector((state: any) => state.auth);
  const [checked, setChecked] = useState<boolean>(!!defaultChecked);

  const handleChange = async (e: React.ChangeEvent, checkState: boolean) => {
    const resp = await asyncPutData({
      apiCode,
      id: idUpdate,
      token,
      data: { [fieldUpdate]: checkState },
    });
    if (!resp || resp?.status !== 200) {
      showAlert({
        type: "error",
        message: resp?.data?.error || resp?.data?.message || "Có lỗi xảy ra",
      });
    } else {
      setChecked(checkState);
    }
  };

  return (
    <Checkbox
      size="small"
      disabled={!!emailCheckSelf ? emailCheckSelf === profile?.email : false}
      checked={checked}
      onChange={handleChange}
    />
  );
}

export default CheckboxUpdate;
